<template>
  <div>
    <section id="filters">
      <vs-divider position="left">Where</vs-divider>
      <spatial-filter :force-active="true" />
      <vs-divider position="left">Sector</vs-divider>
      <div class="sectors-container">
        <app-radio-list
          name="rblSectors"
          class="sectors-radio"
          :items="sectorsList"
          @change="updateActiveSector"
        />
        <img
          :src="
            activeSector.name === sectors.aquaculture.name
              ? require(`@/assets/menus/aquaculture_dark.png`)
              : require(`@/assets/menus/marine_dark.png`)
          "
          class="sector-ico"
        />
      </div>
    </section>
    <br />
    <div class="button">
      <vs-button
        type="filled"
        size="large"
        icon="dns"
        color="#19535F"
        @click="checkOperativity()"
        >Check Operativity</vs-button
      >
    </div>
  </div>
</template>
<script>
import SpatialFilterControl from "@/components/ui/SpatialFilterControl";
import AppRadioButtonList from "@/components/ui/AppRadioButtonList";
import {
  CONFIG_OPERATIVITY_AQUA,
  CONFIG_OPERATIVITY_ENERGY
} from "@/config/bluegrowth-config.js";
import { SECTORS } from "@/constants.js";
import { BTM_PANELS } from "@/constants.js";
import { getProduct } from "@/api/mercurio";
import { sectorsMixin } from "@/mixins/sector.js";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    "spatial-filter": SpatialFilterControl,
    "app-radio-list": AppRadioButtonList
  },
  mixins: sectorsMixin,
  props: {
    momentId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      activeSector: {},
      varsAqua: CONFIG_OPERATIVITY_AQUA.shortTerm.variables,
      varsEnergy: CONFIG_OPERATIVITY_ENERGY.shortTerm.variables,
      sectors: SECTORS,
      sectorsList: []
    };
  },
  computed: {
    ...mapState("map", {
      marker: state => state.marker
    })
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions({
      setBluegrowthOperativityInputs: "setBluegrowthOperativityInputs",
      setBTMBlueGrowthActivePanel: "setBTMBlueGrowthActivePanel",
      toggleLoading: "toggleLoading"
    }),
    init() {
      this.setSectorsList();
    },
    checkOperativity() {
      if (this.isAquacultureActive) {
        this.loadProductsForOperativity(this.varsAqua);
      } else {
        this.loadProductsForOperativity(this.varsEnergy);
      }
    },
    async loadProductsForOperativity(variables) {
      const productsOP = [];
      try {
        this.toggleLoading(true);
        for (const variable of variables) {
          const product = await getProduct(variable.productId);
          var fullProduct =
            variable.id === 0
              ? this.setupProductWithComponents(product, variable)
              : this.setupProduct(product, variable);

          productsOP.push(fullProduct);
        }
        this.setBluegrowthOperativityInputs({
          variables: variables,
          products: productsOP
        });
      } catch (error) {
        this.$_utilsMixin_notify("Error getting operativity data", error, 2);
      } finally {
        this.toggleLoading(false);
        this.setBTMBlueGrowthActivePanel(BTM_PANELS.BLUEGROWTH.VIEWER);
      }
    },
    setupProduct(product, variable) {
      const productVar = product.variables.find(productVar => {
        return productVar.id === variable.id;
      });
      productVar.thresholds = variable.thresholds;
      product.hasComponents = false;
      product.variable = productVar;
      return product;
    },
    setupProductWithComponents(product, variable) {
      /* setup product for vector variable (ie:wind, currents, etc...) */
      const productVar = {
        shortName: variable.name,
        units: variable.units,
        alias: variable.alias
      };
      productVar.thresholds = variable.thresholds;
      product.variable = productVar;
      product.hasComponents = true;
      const u = product.variables.find(u => {
        return u.id === variable.components[0].id;
      });
      const v = product.variables.find(v => {
        return v.id === variable.components[1].id;
      });
      product.u = u;
      product.v = v;
      return product;
    },
    setSectorsList() {
      for (const sectorKey of Object.keys(this.sectors)) {
        this.sectorsList.push(this.sectors[sectorKey]);
      }
    },
    updateActiveSector(sector) {
      this.activeSector = sector;
    }
  }
};
</script>
<style scoped>
.button {
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
  margin-right: 1rem;
}
.datatable {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.sectors-container {
  display: flex;
  margin-right: 1rem;
}
.sectors-radio >>> li {
  padding: 0px !important;
}
.sector-ico {
  width: 50px;
  height: 50px;
}
</style>
